import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

//pages
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import PageNotFound from './pages/PageNotFound';
import RedirectExample from './pages/RedirectExample';

import ProjectIndex from './pages/projects/Index';
import ProjectShow from './pages/projects/Show';

import MusicIndex from './pages/music/Index';

//components
import NavBar from './components/NavBar';

const App = () => {
    return (
        <Router>

            <NavBar />

            <Routes>
                <Route path={"/"} element={<Home />} />
                <Route path={"/about"} element={<About />} />
                <Route path={"/contact"} element={<Contact />} />
                <Route path={"/redirect-example"} element={<RedirectExample />} />

                {/* Projects */}
                <Route path={"/projects"} element={<ProjectIndex />} />
                <Route path={"/projects/:slug"} element={<ProjectShow />} />

                {/* Music */}
                <Route path={"/music"} element={<MusicIndex />} />


                <Route path="*" element={<PageNotFound />} />
            </Routes>


        </Router>
    )
};

export default App;